import { render, staticRenderFns } from "./MislakaConsentSuccess.vue?vue&type=template&id=2971ec14&scoped=true"
import script from "./MislakaConsentSuccess.vue?vue&type=script&lang=js"
export * from "./MislakaConsentSuccess.vue?vue&type=script&lang=js"
import style0 from "./MislakaConsentSuccess.vue?vue&type=style&index=0&id=2971ec14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2971ec14",
  null
  
)

export default component.exports